export default {
    common: {
        email: '電郵',
        LoginBtn: '登錄',
        SignUpBtn: '註冊',
        SubmitBtn: '提交',
        ExitBtn: '退出',
        LogoutBtn: '登出'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: '請於電郵內查收驗證碼',
        VerificationCode: '驗證碼'
    },
    header: {
        OrderHistory: '訂單記錄',
        MYACCOUNT: '我的賬戶',
        WelcomeBack: '歡迎回來'
    },
    detail: {
        TotalOrders: '訂單總數',
        TotalProducts: '產品總數',
        WonderlandPoints: 'Wonderland積分',
        APMCredits: 'APM積分',
        ExpireOn: '有效期限',
        NoAPMCredits: '暫無APM積分',
        CreditsLoading: '積分加載中',
        Orders: '訂單',
        Online: '網上商店',
        Boutique: '精品店',
        Total: '總計',
        Delivered: 'Delivered',
        NoData: '暫無數據',
        Status: '狀態',
        item: '商品',
        items: '商品'
    },
    panel: {},
    entry: {
        Client: '顧客',
        OrderDate: '訂單日期',
        DeliverDate: '送達日期',
        Description: '描述',
        Total: '合計'
    },
    board: {
        Order: '訂單',
        Date: '日期',
        Total: '合計'
    },
    order: {
        OrderID: '訂單編號',
        PurchasePlace: '購買地點',
        PurchaseDate: '購買日期',
        TotalPrice: '總價',
    },
    product: {
        Name: '商品名稱',
        SKU: '商品SKU',
        Size: '商品尺碼',
        Quantity: '商品數量',
        Price: '商品價格',
        WarrantyUntil: '保修期至',
    },
    ordersLayout: {
            pageTitleOrders: "訂單",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "主頁",
            navProfile: "個人資料",
            navOrders: "訂單",
            navWonderland: "Wonderland",
            navWishlist: "願望清單",
            navContactUs: "聯絡我們",
            navExchangeReturn: "換貨與退貨",
            footerExchangePolicy: "換貨與退貨政策",
            footerShipping: "配送",
            footerPrivacy: "私隱政策",
            footerTerms: "服務條款",
            footerRegion: "法國",
            menuTrackOrder: "追蹤訂單",
            menuViewDetails: "查看詳情",
            back: "返回",
            orderNumberHeading: "訂單編號 {{id}}",
            itemsCount_one: "{{count}} 件商品",
            itemsCount_other: "{{count}} 件商品",
            emptyOrders: "您尚未有任何訂單。",
            loading: "載入中",
            invoiceSoon: "即將推出",
            storeAddressPending: "地址稍後提供",
            skuPrefix: "SKU",
            statusLabel: "狀態",
            productNameFallback: "商品",
            tabOnline: "線上",
            tabOffline: "線下",
            learnMore: "了解更多",
            redeemInStore: "到店兌換",
            dateLabel: "日期",
            itemSingular: "商品",
            statusConfirmed: "已確認",
            purchaseDateLabel: "購買日期：",
            monthJan: "1月",
            monthFeb: "2月",
            monthMar: "3月",
            monthApr: "4月",
            monthMay: "5月",
            monthJun: "6月",
            monthJul: "7月",
            monthAug: "8月",
            monthSep: "9月",
            monthOct: "10月",
            monthNov: "11月",
            monthDec: "12月",
            storeLabel: "店舖",
            downloadInvoice: "下載發票",
            warrantyExpires: "保修期至",
            sizeLabel: "尺碼",
            subtotalLabel: "小計",
            totalLabel: "總計",
            ecListTitle: "您的訂單",
            ecStatusInStore: "狀態：店舖購買",
            ecOrderNumber: "訂單編號：{{order_number}}",
            ecDateStore: "{{date}} · {{store_name}}",
            ecCountTotalOne: "{{count}} 件商品：總計 {{amount}}",
            ecCountTotalOther: "{{count}} 件商品：總計 {{amount}}",
            ecViewOrder: "查看訂單 >",
            ecViewOrderA11y: "查看訂單 {{order_number}}",
            ecBackToOrders: "返回您的訂單",
            ecInStoreDate: "店舖購買 – {{date}}",
            ecProductsOne: "商品",
            ecProductsOther: "商品",
            ecSku: "貨號：{{sku}}",
            ecQty: "數量：{{qty}}",
            ecWarrantyExpired: "已過保養期",
            ecWarrantyActive: "保養期內",
            ecSubtotalOne: "小計 – {{count}} 件商品",
            ecSubtotalOther: "小計 – {{count}} 件商品",
        },
}



// WEBPACK FOOTER //
// ./src/locales/tc/index.js